// SunDrip™ — UI scripts

var _modalVariantId = null;

function openModal(name, variantId) {
  document.querySelector('.modal-name').textContent = name;
  _modalVariantId = variantId || null;
  document.querySelector('.modal-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeModal() {
  document.querySelector('.modal-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

document.querySelector('.modal-overlay').addEventListener('click', function(e) {
  if (e.target === this) closeModal();
});

function selSize(btn) {
  document.querySelectorAll('.modal-size').forEach(function(b) { b.classList.remove('sel'); });
  btn.classList.add('sel');
}

function addToCartModal() {
  var sizeBtn = document.querySelector('.modal-size.sel');
  if (!sizeBtn) {
    alert('Please select a size first.');
    return;
  }
  var count = document.querySelector('.cart-count');
  if (count) count.textContent = parseInt(count.textContent || '0') + 1;
  closeModal();
}

// Filter tabs — highlights active tab only
function filterProducts(cat, btn) {
  document.querySelectorAll('.filter-tab').forEach(function(t) { t.classList.remove('active'); });
  btn.classList.add('active');
}

// Collection sort — reload with sort_by param
function sortCollection(value) {
  var url = new URL(window.location.href);
  if (value) {
    url.searchParams.set('sort_by', value);
  } else {
    url.searchParams.delete('sort_by');
  }
  window.location.href = url.toString();
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeModal();
});

document.addEventListener('DOMContentLoaded', function() {
  var defaultSize = document.querySelector('.modal-size[data-size="M"]');
  if (defaultSize) defaultSize.classList.add('sel');
});
